import React, { useEffect, useState } from "react";
import * as S from "./styles";
import { plans } from "@/constants/plans";
import { api } from "@/services/api";

interface PlansChooserTypes extends React.ComponentPropsWithoutRef<'button'>{
  planHandler: (plan: keyof typeof plans) => void;
  
}

interface SellerInfo {
  name: string
  link: string
}

export default function PlansChooser({ planHandler, ...props }: PlansChooserTypes) {

  return (
    <>
      <S.OurPlansWrapper>
        <h2>Nossos Planos</h2>
        <p>Escolha o seu plano</p>
        <S.PlansButton onClick={() => planHandler("monthly")} {...props}>
          <div>
            <span>Mensal</span>
            <p>
              <span>De R$159,90</span>
              <br />
              por R$89,90
            </p>
          </div>
        </S.PlansButton>
        <S.PlansButton onClick={() => planHandler("semiannual")} {...props}>
          <div>
            <span>Semestral</span>
            <p>
              <span>De R$314,90</span>
              <br />
              por R$34,90/6 meses
            </p>
          </div>
          <S.DiscountTag>
            <p>20% de desconto</p>
          </S.DiscountTag>
        </S.PlansButton>
        <S.PlansButton onClick={() => planHandler("annual")} {...props}>
          <div>
            <span>Anual</span>
            <p>
              <span>De R$249,90</span>
              <br />
              por R$19,90/12 meses
            </p>
          </div>
          <S.DiscountTag>
            <p>25% de desconto</p>
          </S.DiscountTag>
        </S.PlansButton>
      </S.OurPlansWrapper>
    </>
  );
}
